import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import QuestionList from "./pages/QuestionList";
import QuestionDetail from "./pages/QuestionDetail";
import BulkImport from "./pages/BulkImport";
import ArchiveList from "./pages/ArchiveList";
import PassiveQuestions from "./pages/PassiveQuestions";
import ApiAccess from "./pages/ApiAccess";
import ApiKeysPage from "./pages/ApiKeysPage";
import MediaManager from "./pages/MediaManager";
import DataQuality from "./pages/DataQuality";
import AdminUsers from "./pages/AdminUsers";
import TaxonomyManager from "./pages/TaxonomyManager";
import TaxonomyStats from "./pages/TaxonomyStats";
import QualityControl from "./pages/QualityControl";
import { Toaster } from "./components/ui/sonner";
import "./App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="questions" element={<QuestionList />} />
            <Route path="questions/new" element={<QuestionDetail />} />
            <Route path="questions/:id" element={<QuestionDetail />} />
            <Route path="import" element={<BulkImport />} />
            <Route path="archives" element={<ArchiveList />} />
            <Route path="media" element={<MediaManager />} />
            <Route path="passive" element={<PassiveQuestions />} />
            <Route path="access" element={<ApiAccess />} />
            <Route path="api-keys" element={<ApiKeysPage />} />
            <Route path="quality" element={<QualityControl />} />
            <Route path="admin-users" element={<AdminUsers />} />
            <Route path="taxonomy" element={<TaxonomyManager />} />
            <Route path="stats" element={<TaxonomyStats />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
